// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__bXN0e","footer__sitemap":"footer_footer__sitemap__b6MLc","footer__sitemap__item":"footer_footer__sitemap__item__izX26"};